module.exports = __webpack_public_path__ + "img/login.c64333ca.png";